import { ProgressIndicator } from '@fluentui/react';
import { doc, onSnapshot } from 'firebase/firestore';

import RenderDialog from '../../../../addons/RenderDialog';
import { firestore } from '../../../../App/firebase';
import { getAsync } from '../../../../utils/api';

export default async (formId: string) => {
  const encodedFormId = encodeURIComponent(formId);
  const { data: formData, versionId } = await getAsync(
    `/forms/get?id=${encodedFormId}`
  );

  const fileName = `${
    formData.account?.displayName || "Bilinmeyen"
  } (${formId}).png`;

  if (!formData.PNGDocumentId) {
    let closeModal: () => void;

    const removeListener = onSnapshot(
      doc(firestore, "forms_v2", formId, "versions", versionId),
      (snapshot) => {
        console.log(snapshot.data());
        if (snapshot.data()!.PNGDocumentId) {
          removeListener();
          downloadPNG(encodedFormId, fileName).then(closeModal);
        }
      }
    );

    closeModal = RenderDialog({
      title: "Resim Oluşması Bekleniyor",
      subText:
        "Bu işlem birkaç dakika sürebilir. Sayfayı kapatmak bu işlemi etkilemez. İndirmeye otomatik olarak başlar.",
      showCloseButton: true,
      onClosed: removeListener,
      children: <ProgressIndicator />,
    });
  } else {
    await downloadPNG(encodedFormId, fileName);
  }
};

const downloadPNG = async (encodedFormId: string, name: string) => {
  const pdf = await getAsync("/forms/get-png?id=" + encodedFormId);
  const url = URL.createObjectURL(pdf);

  const a = document.createElement("a");
  a.href = url;
  a.download = name;

  a.click();
  a.remove();
};
